import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { DataTypes, ViewServiceRequestData } from "../../Types/UnitFeatureTypes";

interface BuildServiceRequestsTableProps {
    item: ViewServiceRequestData[];
}

const BuildServiceRequestsTable: React.FC<BuildServiceRequestsTableProps> = ({
    item
}) => {
    const navigate = useNavigate();

    const getTableData = (item: ViewServiceRequestData[]) => {
        return (<Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{fontWeight: 600}} align="center">Created Date</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Title</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Unit</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Priority</TableCell>
                    <TableCell sx={{fontWeight: 600}} align="center">Status</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {item.map((serviceRequest: ViewServiceRequestData) =>
                    <TableRow key={serviceRequest.id} sx={{'&:hover': {
                        backgroundColor: '#f5f5f5',
                        cursor: 'pointer'
                    }}} onClick={() => serviceRequest.id !== undefined && handleViewServiceRequest(Number(serviceRequest.id))}>
                        <TableCell align="center">{new Date(serviceRequest.created_on).toDateString()}</TableCell>
                        <TableCell sx={{maxWidth: 100}} align="center">
                            <Tooltip title={serviceRequest.title}>
                                <Typography variant="body2" color="textSecondary" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {serviceRequest.title}
                                </Typography>
                            </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                            <Typography variant="body2" color="textSecondary">{serviceRequest.unit_number}</Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography variant="body2" color="textSecondary">{serviceRequest.priority}</Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography variant="body2" color="textSecondary">{serviceRequest.status}</Typography>
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>)
    }

    if (!item.length) {
        return (
            <Paper elevation={3} sx={{borderRadius: 3, padding: 2, alignItems: 'center', display: 'flex', justifyContent: 'center'}}>
                <Typography variant="subtitle1" fontWeight={600} color="textSecondary">No Service Request Available</Typography>
            </Paper>
        )
    }

    const handleViewServiceRequest = (id: number) => {
        navigate(`/viewServiceRequest`, { state: { id, type: DataTypes.SERVICE_REQUEST } });
    }

    return (
        <Paper elevation={3} sx={{borderRadius: 3, overflow: 'auto'}}>
            {getTableData(item)}
        </Paper>
    )
}

export default BuildServiceRequestsTable;